<template>
  <div class="w-full relative" v-outside="closeOptions">
    <div class="bg-secondary w-full border border-default rounded-sm flex items-center px-1">
      <div class="w-40 flex items-center justify-center">
        <search-icon />
      </div>
      <input type="text" v-model="searchQuery" class="search-input" :placeholder="$t('search')"
      :class="heightClass" />
      <div
        class="cursor-pointer rounded-sm"
        @click="displayOptions = !displayOptions"
        :class="[{'bg-tertiary': displayOptions }, heightClass, squareWidthClass]"
      >
        <span class="h-full w-full flex items-center justify-center">...</span>
      </div>
    </div>
    <div
      v-if="displayOptions && options.length"
      class="absolute bg-secondary w-full shadow-md rounded p-10"
    >
      <span class="font-normal text-12 text-subtitle">{{ $t('search') }}</span>
      <div class="mt-10">
        <div v-for="(option, index) in options" :key="index" class="pb-10">
          <label :for="`search-${option}`">
            <input
              type="checkbox"
              :id="`search-${option}`"
              class="check-box-classes"
              v-model="selectedOptions"
              :value="option"
            />
            <span class="font-normal text-12 px-10">
              {{ $t(`${option}`) }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from 'lodash.debounce';
import outside from '@/directives/clickOutSide';
import SearchIcon from '@/assets/icons/vue/search_normal.vue';

export default {
  components: {
    SearchIcon,
  },
  props: {
    options: {
      type: Array,
      required: true,
    },
    defaultOption: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: '50',
    },
  },
  data() {
    return {
      searchQuery: '',
      displayOptions: false,
      selectedOptions: [],
      initialLoad: false,
    };
  },
  directives: {
    outside,
  },
  mounted() {
    if (this.defaultOption) {
      this.selectedOptions.push(this.defaultOption);
      this.$emit('selectedOptions', this.selectedOptions);
    }
  },
  computed: {
    heightClass() {
      return `h-${this.height}`;
    },
    squareWidthClass() {
      return `w-${this.height}`;
    },
  },
  watch: {
    selectedOptions: {
      handler() {
        if (this.initialLoad && this.defaultOption) {
          this.$emit('selectedOptions', this.selectedOptions);
        }
        this.initialLoad = true;
      },
      deep: true,
    },
    searchQuery:
      // eslint-disable-next-line func-names
      debounce(function () {
        this.$emit('searchQuery', this.searchQuery);
      }, 300),
  },
  methods: {
    closeOptions() {
      this.displayOptions = false;
    },
  },
};
</script>
<style scoped>
.search-input {
  @apply w-full bg-secondary border-none focus:ring-0 font-normal text-14;
}
</style>
